import React, { Suspense } from "react";
import Loadable from "components/_Shared/commonLoadable";

import { makeRoutes, makeRedirects } from "./utils";

import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { gtmPushEcommerce } from "utils/trackingEvents/axonEcommerce";

const routes = makeRoutes();
const redirects = makeRedirects();

const router = createBrowserRouter([...routes, ...redirects]);

// Fire GA4 page_view on every route change for the Axon Pixel (via GTM).
// The initial page load is tracked here; subsequent SPA navigations fire
// once the router transition settles back to "idle".
gtmPushEcommerce("page_view");
let lastTrackedPath = window.location.pathname + window.location.search;
router.subscribe(state => {
  if (state.navigation.state !== "idle") return;
  const path = state.location.pathname + state.location.search;
  if (path === lastTrackedPath) return;
  lastTrackedPath = path;
  gtmPushEcommerce("page_view");
});

const Routes = props => {
  return (
    <Suspense fallback={<Loadable active isChildren />}>
      <RouterProvider router={router} />
    </Suspense>
  );
};

export default Routes;
